import React from "react";
import { Link } from "react-router-dom";
import { Col } from "react-bootstrap";
import { TextField, EmailField, PasswordField } from "../../Shared/FormHelpers";
import {
  SignUpButton,
  SignUpPanel,
  LoginLink,
  FooterContainer,
} from "./styles";
import { Title } from "../Common/index.style";
import Loader from "../../Shared/Loader";

const SignUpForm = (props) => {
  const {
    handleSubmit,
    handlePassword,
    handleCompanyName,
    handleConfirmPassword,
    handleEmail,
    handleLastName,
    handleFirstName,
    loading,
  } = props;
  return (
    <SignUpPanel>
      <form onSubmit={handleSubmit}>
        <Col xs={12} md={12}>
          <Title className="">Create an Account</Title>
          <TextField
            onChange={handleFirstName}
            title="First Name"
            id="fname"
            placeholder="john"
          />
          <TextField
            onChange={handleLastName}
            title="Last Name"
            id="lname"
            placeholder="doe"
          />
          <EmailField
            onChange={handleEmail}
            title="email address"
            id="email"
            placeholder="johndoe@gmail.com"
          />
          <TextField
            onChange={handleCompanyName}
            title="company name"
            id="name"
            placeholder="company A"
          />
          <PasswordField
            onChange={handlePassword}
            title="password"
            id=""
            placeholder="******"
          />
          <PasswordField
            onChange={handleConfirmPassword}
            title="confirm Password"
            id=""
            placeholder="******"
          />
        </Col>
        <FooterContainer>
          <LoginLink>
            <p>
              Have an account? Login
              <Link
                style={{ padding: "0 1rem" }}
                to={{
                  pathname: "/login",
                  redirect: "/payment",
                }}
              >
                here
              </Link>
            </p>
          </LoginLink>
          <div>
            <SignUpButton bsSize="large" type="submit" disabled={loading}>
              {!loading && "Sign Up"}
              <Loader height="25px" width="25px" show={loading} />
            </SignUpButton>
          </div>
        </FooterContainer>
      </form>
    </SignUpPanel>
  );
};

export default SignUpForm;
